import React from "react";
import { Spinner } from "@blueprintjs/core";

export default function CustomLoader() {
    return (
        <div>
            <Spinner />
            <div style={{ textAlign: "center", fontSize: "1rem" }}>Loading...</div>
        </div>
    );
}
